import { useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { userSelector } from "../user-redux/selector";
import { executeAdvancedOptimise } from "./advancedOptimiseService";
import { getJobDescriptionText } from "./resumeDataUtils";

export default function useAdvancedOptimise() {
  const navigate = useNavigate();
  const { user } = useSelector(userSelector);
  const [analysing, setAnalysing] = useState(false);
  const [error, setError] = useState("");

  const runAdvancedOptimise = useCallback(
    async ({ resumeId, jobDescription, jobTitle }) => {
      if (!resumeId) {
        setError("Resume ID not found.");
        return;
      }

      const jdText =
        typeof jobDescription === "string"
          ? jobDescription
          : getJobDescriptionText({ job_description: jobDescription });

      if (!jdText) {
        setError("Job description not available.");
        return;
      }

      setAnalysing(true);
      setError("");

      try {
        const payload = await executeAdvancedOptimise({
          resumeId,
          jobDescription: jdText,
          userId: user?.id,
        });

        navigate(`/resume/advanced-optimise/resume_${resumeId}`, {
          state: {
            advancedOptimisePayload: payload,
            jobDescription: jdText,
            jobTitle: jobTitle || "",
          },
          replace: false,
        });
      } catch (err) {
        setError(err.message || "Failed to optimise resume.");
      } finally {
        setAnalysing(false);
      }
    },
    [navigate, user?.id]
  );

  const clearError = useCallback(() => setError(""), []);

  return { runAdvancedOptimise, analysing, error, clearError };
}
